export default __webpack_public_path__ + "static/c2-602dfc0240cf60ceed4e7db532253980.png";